import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useCustomerHasActiveOrUpcomingMembership_session$key } from "./__generated__/useCustomerHasActiveOrUpcomingMembership_session.graphql";

export const useCustomerHasActiveOrUpcomingMembership = (
  sessionRef?: useCustomerHasActiveOrUpcomingMembership_session$key | null
) => {
  const session = useFragment(
    useCustomerHasActiveOrUpcomingMembershipFragmentString,
    sessionRef
  );

  const customer = session?.currentClientProfile?.member;

  return (
    (customer?.memberPackages?.count || 0) > 0 ||
    (customer?.upcomingMemberPackages?.count || 0) > 0
  );
};

const useCustomerHasActiveOrUpcomingMembershipFragmentString = graphql`
  fragment useCustomerHasActiveOrUpcomingMembership_session on Session {
    currentClientProfile {
      member {
        ... on Customer {
          id
          memberPackages(status: ACTIVE, type: MEMBERSHIP) {
            count
          }
          upcomingMemberPackages: memberPackages(
            status: UPCOMING
            type: MEMBERSHIP
          ) {
            count
          }
        }
      }
    }
  }
`;
